import { NgIf } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FuseConfigService } from '@fuse/services/config';
import { AuthService } from 'app/core/auth/auth.service';
import { FuseCardComponent } from '@fuse/components/card';
import { Navigation } from 'app/core/navigation/navigation.types';
import { FuseHorizontalNavigationComponent, FuseNavigationItem, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import Swal from 'sweetalert2';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { LandingService } from 'app/services/landing.service';
import { PaymentService } from 'app/services/payment.service';
import { Subscription, lastValueFrom, switchMap } from 'rxjs';
import { SubscriptionService } from 'app/services/subscription.service';
import { NavigationComponent } from 'app/modules/navigation/navigation.component';
import { from } from 'rxjs';
import { ProfileManagementService } from 'app/services/profile-management.service';
import _ from 'lodash';
import { SharedMethods } from 'app/shared/shared-methods';
import { MobileNavigation } from 'app/modules/mobile-navigation/navigation.component';
import { MatDialog } from '@angular/material/dialog';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
// import { VoucherService } from 'app/services/voucher.service';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { SocialService } from 'app/services/social-service';

declare let AOS: any;
@Component({
  selector: 'app-social-sign-up',
  templateUrl: './social-sign-up.component.html',
  styleUrls: ['./social-sign-up.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  standalone: true,
  imports: [RouterLink, MatStepperModule, FuseCardComponent, NavigationComponent, ButtonsModule, NgxMatIntlTelInputComponent, NgOtpInputModule, MobileNavigation, FuseAlertComponent, FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent, NgIf, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatProgressSpinnerModule,],
})



export class SocialSignUpComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('template') myTemplate: TemplateRef<any>;
  @ViewChild('fuseCard') fuseCard!: FuseCardComponent;
  @ViewChild('registerNgForm') registerNgForm: NgForm;

  mainNavigation: FuseNavigationItem[];
  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: '',
  };

  // public voucherSubId: number;

  public registerForm: UntypedFormGroup;
  public showAlert: boolean = false;
  public selectedSubscription: string;
  public subscriptionDetails: any;
  public expanded: boolean;
  public experience: boolean = true;
  public liveEvents: boolean = true;
  public whatsAppConsent: boolean = false;
  public emailConsent: boolean = true;
  public validPassword: boolean = true;
  public showSpinner: boolean;
  public receiever: any;
  public payfastDialog: boolean = false;
  public terms: boolean = false
  public showPasswordError: boolean = false;
  public showErrors: boolean = false;
  public useMobileOtpVerification: boolean = false;
  public otpTitle: string;
  public isMobile: boolean;
  public isResendDisabled = false;
  public countdown: number = 60;
  public showOtp: boolean;
  public otpValue: number;
  public registered: boolean;
  public showPhoneNumber: boolean;
  public showLoader: boolean;

  private confirmPassword: Subscription | undefined;
  private whatsAppCheck: Subscription | undefined;
  private preferences: Subscription | undefined;
  private phoneValueCheck: Subscription | undefined;
  private sendOtpResult: any;
  private verifyOtpResult: any;
  private verifyEmail: any;
  private verifyCoupon: any;
  private strongPasswordRegx: RegExp =
    /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  private phoneNumber: string;
  private name: string;
  private surname: string;
  private email: string;
  private socialType: string;
  private socialToken: string;
  private consentUpdated: boolean;

  /**experience
   * Constructor
   */
  constructor(
    private _authService: AuthService,
    private _formBuilder: UntypedFormBuilder,
    private _fuseConfig: FuseConfigService,
    private _router: Router,
    private _navService: NavigationService,
    public paymentService: PaymentService,
    private _subscriptionService: SubscriptionService,
    private _managementService: ProfileManagementService,
    public sharedMethods: SharedMethods,
    private _matDialog: MatDialog,
    private socialService: SocialService

    // private _voucherService: VoucherService,
  ) {
    const socialLogin = this._authService.socialLogin;


    if (!socialLogin) {
      this._router.navigateByUrl(`/home`);
    }


    this.email = sessionStorage.getItem("email");
    this.socialType = sessionStorage.getItem("socialType");
    this.socialToken = this._authService.socialToken;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  async ngOnInit(): Promise<void> {

    AOS.init({
      offset: -100,

    });
    this._navService.titleName = "Login"
    this._navService.navUrl = "/sign-in"
    // Create the form

    this.registerForm = this._formBuilder.group({
      phoneNumber: [''],
      liveEvents: [this.liveEvents],
      experience: [this.experience],
      terms: [this.terms],
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      coupon: [''],
    });

    this.preferences = this.registerForm.get('password')?.valueChanges.subscribe(text => {
      if (text.length > 0) {
        this.expanded = true;
      } else {
        this.expanded = false;
      }
    });



  }

  ngOnDestroy(): void {
    // this.preferences.unsubscribe();
    // this.confirmPassword.unsubscribe();
    // this.phoneValueCheck.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------


  public async register() {
    this.showLoader = true;
    this.showSpinner = true;
    await this.registerContinue();
  }


  public async registerContinue() {
    this.showSpinner = true;
    const terms = this.registerForm.get('terms').valid;
    if (!terms) {
      this.sharedMethods.showNotification("Acceptance of Terms and conditions is mandatory", true).then(() => {
      })
      return;
    }

    await this.addConsent();
  }


  private async addConsent() {
    const userdata = {
      email: this.email,
      socialToken: this.socialToken,
      socialType: this.socialType
    };
    await this.socialService.login(userdata).then(async () => {
       await lastValueFrom(this._managementService.updateConsent({
        individualConsent: {
          id: this._authService.getUserKeyValue("consent").consent_id,
          ref_user: this._authService.getUserKeyValue("user"),
          email: this._authService.getUserKeyValue("email"),
          name: this._authService.getUserKeyValue("name"),
          surname: this._authService.getUserKeyValue("surname"),
          consent_all: true,
          consent_live_events: this.registerForm.value.liveEvents,
          consent_experience_enhancements: this.registerForm.value.experience,
          communication_consent_all: true,
          whatsapp_communication: this.registerForm.value.whatsAppConsent,
          email_communication: this.registerForm.value.emailConsent
        }
      })).catch(() => {
        return "Error"
      }).then((res) => {
        this.consentUpdated = true;
        this._router.navigateByUrl(`/member/home`);
      })
    })
  }

 

  public closeModal() {
    this._matDialog.closeAll();
  }


  public homePage() {
    this._router.navigateByUrl(`/home`);
  }


  public registerPage() {
    this._router.navigateByUrl(`/sign-in`);
  }




}